import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=5585140c"
import script from "./Bookings.vue?vue&type=script&lang=js"
export * from "./Bookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports